import React from "react";
import "../Style/aboutusway.css";

// Top right blue image
import blueShape from "../assets/blue-logo.png";

const icons = {
  teamwork: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <circle cx="8" cy="8" r="3" />
      <circle cx="17" cy="9" r="2.4" />
      <path d="M2.5 20c.6-3.5 2.9-5.5 5.5-5.5s4.9 2 5.5 5.5M14.5 20c.4-2.6 1.9-4.2 4-4.2s3.6 1.6 4 4.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  curiosity: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M9 18h6M10 21h4" strokeLinecap="round" />
      <path d="M12 3a6.5 6.5 0 0 0-3.8 11.8c.6.4 1 1.1 1 1.9v.3h5.6v-.3c0-.8.4-1.5 1-1.9A6.5 6.5 0 0 0 12 3Z" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  empathy: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M12 20s-7.5-4.6-9.7-9.4C.8 7.3 2.4 4 5.7 4c1.9 0 3.4 1 4.3 2.5C10.9 5 12.4 4 14.3 4c3.3 0 4.9 3.3 3.4 6.6C15.5 15.4 12 20 12 20Z" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  integrity: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M12 3 4.5 6v6c0 4.5 3 7.5 7.5 9 4.5-1.5 7.5-4.5 7.5-9V6L12 3Z" strokeLinecap="round" strokeLinejoin="round" />
      <path d="m9 12 2 2 4-4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  transparency: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M1.5 12S5 5.5 12 5.5 22.5 12 22.5 12 19 18.5 12 18.5 1.5 12 1.5 12Z" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),
  ubuntu: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <circle cx="12" cy="6" r="2.2" />
      <circle cx="6" cy="16" r="2.2" />
      <circle cx="18" cy="16" r="2.2" />
      <path d="M10.5 7.8 7.5 14.2M13.5 7.8l3 6.4M8.2 16.5h7.6" strokeLinecap="round" />
    </svg>
  ),
};

const data = [
  {
    icon: "teamwork",
    title: "Teamwork",
    desc: "Collaboration drives our success. Together, we create extraordinary results.",
  },
  {
    icon: "curiosity",
    title: "Curiosity",
    desc: "In a world that never stands still, we thrive on curiosity and continuous growth.",
  },
  {
    icon: "empathy",
    title: "Empathy",
    desc: "We connect on a deeper level with your audience, ensuring every story strikes a chord.",
  },
  {
    icon: "integrity",
    title: "Integrity",
    desc: "Honesty and accountability form the foundation of every relationship we build.",
  },
  {
    icon: "transparency",
    title: "Transparency",
    desc: "Openness fosters trust, and trust is the cornerstone of lasting partnerships.",
  },
  {
    icon: "ubuntu",
    title: "Ubuntu",
    desc: "I am because you are because we are.",
  },
];

export default function AboutUsWay() {
  return (
    <section className="aboutway-section">
      <div className="aboutway-glow" />

      <div className="aboutway-container">

        {/* LEFT CONTENT */}
        <div className="aboutway-left">
          <h2 className="aboutway-title">The MPeoples Way</h2>
          <p className="aboutway-subtitle">
            Where bold ideas meet shared values and everyday magic.
          </p>

          <div className="aboutway-grid">
            {data.map((item, index) => (
              <div className="aboutway-card" key={index}>
                <div className="aboutway-icon-wrap">{icons[item.icon]}</div>
                <h4 className="aboutway-card-title">{item.title}</h4>
                <p className="aboutway-card-desc">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div className="aboutway-right">
          <img src={blueShape} alt="shape" />
        </div>

      </div>
    </section>
  );
}